import { Button, ButtonSize } from '@atlas/components';
import { PaymentMethodType } from 'api/payments';
import Icon from 'components/Icon/Icon';
import type { FC, MouseEvent, ReactNode } from 'react';
import { Translation } from 'utils/translations';
import DepositAmountTemplateList from './DepositAmountTemplateList';

import styles from './PaymentForm.module.scss';

type ContainerComponentProps = {
  children: ReactNode;
  onSubmit: (e: MouseEvent<HTMLButtonElement>) => void;
  method: PaymentMethodType;
  isDisabledSubmitButton: boolean;
  handleSelectDepositAmount: (amount: number) => void;
  fieldValue?: number;
};

const ContainerComponent: FC<ContainerComponentProps> = ({
  children,
  handleSelectDepositAmount,
  onSubmit,
  method,
  isDisabledSubmitButton,
  fieldValue,
}) => {
  return (
    <form className={styles.form} id="payment_deposit">
      {children}
      {method === PaymentMethodType.DEPOSIT && (
        <DepositAmountTemplateList
          fieldValue={fieldValue}
          onSelectDepositTemplate={handleSelectDepositAmount}
        />
      )}
      <Button
        wide
        size={ButtonSize.big}
        type="submit"
        data-testid="submit"
        onClick={onSubmit}
        disabled={isDisabledSubmitButton}
        icon={
          <Icon
            name={
              method === PaymentMethodType.DEPOSIT
                ? 'wallet-add.bold'
                : 'wallet-minus.bold'
            }
          />
        }
      >
        <Translation
          message={
            method === PaymentMethodType.DEPOSIT ? 'deposit' : 'withdrawal'
          }
        />
      </Button>
    </form>
  );
};

export default ContainerComponent;
